import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AppLayout } from './components/AppLayout';
import { AuthGate } from './auth/AuthGate';
import { Admin } from './pages/Admin';
import { LiveSessions } from './pages/LiveSessions';
import { Overview } from './pages/Overview';
import { SessionDetail } from './pages/SessionDetail';
import { SessionReplayPage } from './pages/SessionReplayPage';
import { Sessions } from './pages/Sessions';
import { useRoute } from './router';
import { useMockSync } from './state/useMockSync';

const client = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

function CurrentRoute() {
  useMockSync();
  const route = useRoute();
  switch (route.name) {
    case 'session':
      return <SessionDetail sessionId={route.id} />;
    case 'replay':
      return <SessionReplayPage sessionId={route.id} />;
    case 'sessions':
      return <Sessions />;
    case 'live':
      return <LiveSessions />;
    case 'admin':
      return <Admin tab={route.tab} />;
    default:
      return <Overview />;
  }
}

export function App() {
  return (
    <QueryClientProvider client={client}>
      {/* One provider for the whole app: the nav's collapsed rail puts every
          label in a tooltip, and a provider created per tooltip would reset
          the shared open/close delay. */}
      <TooltipProvider delayDuration={200}>
        <AuthGate>
          <AppLayout>
            <CurrentRoute />
          </AppLayout>
        </AuthGate>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
